function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef, useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate, T } from 'shared/helper/translate';
import Files, { endpoints } from 'shared/helper/file';
import { FILE_STATUS } from 'shared/helper/file/constants';
import { Controls, useFormHelpers } from 'shared/helper/form';
import FileRubriq from 'shared/helper/file/components/FileRubriq';
import { syncUser } from 'rubriq/actions';
import { createPlagiarism } from 'researcher/plagiarism/actions';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import RubriqUploadButton from '../RubriqUploadButton';
import UploadImage from '../../images/upload.svg';
import { RUBRIQ_PLAN_NAMES_MAP } from '../../constants';
import RubriqPlagiarismStatus from './RubriqPlagiarismStatus';
var uploadFileType = 'ithenticate';
var Form = Controls.Form;
var defaultValues = {
  plagiarismFiles: []
};
var PlagiarismCheckDocumentModal = function PlagiarismCheckDocumentModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    _ref$initialFiles = _ref.initialFiles,
    initialFiles = _ref$initialFiles === void 0 ? null : _ref$initialFiles;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    user = _useSelector.user;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragActive = _useState4[0],
    setDragActive = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentPageIndex = _useState6[0],
    setCurrentPageIndex = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showError = _useState8[0],
    setShowError = _useState8[1];
  var filePickerRef = useRef(null);
  var curie = useSelector(function (state) {
    return state.curie;
  });
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _methods$watch = methods.watch(['plagiarismFiles']),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    plagiarismFiles = _methods$watch2[0];
  var hasFile = plagiarismFiles && plagiarismFiles.length > 0;
  var _useFormHelpers = useFormHelpers(),
    preprocessData = _useFormHelpers.preprocessData;
  var trackedUploadsRef = useRef(new Set());
  var dispatch = useDispatch();
  var paymentDetails = useSelector(function (state) {
    return state.payment;
  });
  var wordCountAttempts = 0;
  useEffect(function () {
    if (open && initialFiles && initialFiles.length > 0) {
      methods.setValue('plagiarismFiles', initialFiles);
    }
  }, [open, initialFiles, methods]);
  var onCheckDocument = function onCheckDocument() {
    if (filePickerRef.current) {
      filePickerRef.current();
    }
  };
  useEffect(function () {
    var _curie$plans$premium$, _curie$plans, _curie$plans2, _file$name, _file$identity, _paymentDetails$id, _paymentDetails$amoun, _paymentDetails$curre, _paymentDetails$metho, _curie$plan$subscript, _curie$plan;
    if (!plagiarismFiles || plagiarismFiles.length === 0) return;
    var file = plagiarismFiles[0];
    var totalFiles = plagiarismFiles.length;
    if (file.status !== FILE_STATUS.STATUS_UPLOAD_SUCCESS) return;
    var fileKey = file.identity;
    if (!fileKey) return;
    if (trackedUploadsRef.current.has(fileKey)) return;
    trackedUploadsRef.current.add(fileKey);
    var getExtension = function getExtension(filename) {
      var _filename$split$pop;
      return (filename === null || filename === void 0 || (_filename$split$pop = filename.split('.').pop()) === null || _filename$split$pop === void 0 ? void 0 : _filename$split$pop.toLowerCase()) || null;
    };
    var extension = getExtension(file.name);
    var rawPlanName = (_curie$plans$premium$ = curie === null || curie === void 0 || (_curie$plans = curie.plans) === null || _curie$plans === void 0 || (_curie$plans = _curie$plans.premium) === null || _curie$plans === void 0 ? void 0 : _curie$plans.planName) !== null && _curie$plans$premium$ !== void 0 ? _curie$plans$premium$ : null;
    var formattedPlanName = RUBRIQ_PLAN_NAMES_MAP[rawPlanName] || rawPlanName || '';
    var isTrial = (curie === null || curie === void 0 || (_curie$plans2 = curie.plans) === null || _curie$plans2 === void 0 || (_curie$plans2 = _curie$plans2.premium) === null || _curie$plans2 === void 0 ? void 0 : _curie$plans2.status) === 'trialing';
    if (isTrial && formattedPlanName) {
      formattedPlanName = "".concat(formattedPlanName, " (Trial)");
    }
    trackRubriqEvent('Plagiarism Document Uploaded', {
      file_name: (_file$name = file.name) !== null && _file$name !== void 0 ? _file$name : null,
      file_type: extension,
      file_identity: (_file$identity = file.identity) !== null && _file$identity !== void 0 ? _file$identity : null,
      uploaded_at: new Date().toISOString(),
      payment_id: (_paymentDetails$id = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.id) !== null && _paymentDetails$id !== void 0 ? _paymentDetails$id : null,
      payment_amount: (_paymentDetails$amoun = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.amount) !== null && _paymentDetails$amoun !== void 0 ? _paymentDetails$amoun : null,
      payment_currency: (_paymentDetails$curre = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.currency) !== null && _paymentDetails$curre !== void 0 ? _paymentDetails$curre : null,
      payment_method: (_paymentDetails$metho = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.method) !== null && _paymentDetails$metho !== void 0 ? _paymentDetails$metho : null,
      second_file_uploaded: totalFiles >= 2,
      third_file_uploaded: totalFiles >= 3,
      planName: formattedPlanName !== null && formattedPlanName !== void 0 ? formattedPlanName : null,
      billing_cycle: (_curie$plan$subscript = curie === null || curie === void 0 || (_curie$plan = curie.plan) === null || _curie$plan === void 0 ? void 0 : _curie$plan.subscriptionInterval) !== null && _curie$plan$subscript !== void 0 ? _curie$plan$subscript : null,
      email: user === null || user === void 0 ? void 0 : user.email,
      user_identity: user.identity
    });
  }, [plagiarismFiles, paymentDetails, curie]);
  var screens = [{
    title: /*#__PURE__*/React.createElement(T, {
      source: "upload-document"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, !hasFile && /*#__PURE__*/React.createElement("div", {
      className: "p-3 mb-3 rounded popup-doc-pannel"
    }, /*#__PURE__*/React.createElement(T, {
      source: "tracked_changes_warning"
    })), /*#__PURE__*/React.createElement("div", {
      className: "".concat(plagiarismFiles.length === 0 ? 'shadow rounded p-2' : '', " ").concat(dragActive ? 'hovered' : '')
    }, /*#__PURE__*/React.createElement(Files, {
      apiRoot: endpoints.researcher,
      maxUploads: 1,
      methods: methods,
      name: "plagiarismFiles",
      type: uploadFileType,
      disabled: submitting,
      fileRenderer: FileRubriq,
      required: true,
      fileUploadButton: function fileUploadButton(_ref2) {
        var onClick = _ref2.onClick,
          isDragActive = _ref2.isDragActive,
          disabled = _ref2.disabled;
        filePickerRef.current = onClick;
        return /*#__PURE__*/React.createElement("div", null, !hasFile && /*#__PURE__*/React.createElement("div", {
          className: "d-flex flex-column align-items-center",
          style: {
            border: "2px dashed ".concat(dragActive ? '#027e6f' : '#e2e8f0'),
            borderRadius: '8px',
            height: '300px',
            width: '103%',
            backgroundColor: dragActive ? '#FAFAFA' : '',
            transition: 'background-color 0.2s ease, border-color 0.2s ease'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "d-flex flex-column align-items-center pt-3 pb-3",
          style: {
            maxWidth: '400px',
            marginTop: '10px'
          }
        }, /*#__PURE__*/React.createElement("img", {
          src: UploadImage,
          alt: ""
        }), /*#__PURE__*/React.createElement("span", {
          className: "fw-semibold fs-4 mt-3"
        }, /*#__PURE__*/React.createElement(T, {
          source: "drag_and_drop_files"
        })), /*#__PURE__*/React.createElement("span", {
          className: "mt-2 text-center"
        }, /*#__PURE__*/React.createElement(T, {
          source: "click_to_browse"
        })), /*#__PURE__*/React.createElement("button", {
          style: {
            borderRadius: '6px'
          },
          type: "button",
          className: "btn btn-primary mt-4",
          onClick: onCheckDocument,
          disabled: submitting
        }, /*#__PURE__*/React.createElement(T, {
          source: "choose_files"
        }), submitting && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          className: "ms-1",
          icon: "fa-solid fa-spinner-scale",
          spin: true
        }))), /*#__PURE__*/React.createElement(RubriqPlagiarismStatus, {
          isNoEditsMessage: true
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'none'
          }
        }, /*#__PURE__*/React.createElement(RubriqUploadButton, {
          onClick: onClick,
          isDragActive: isDragActive,
          disabled: disabled,
          onDragStatusChanged: function onDragStatusChanged(active) {
            return setDragActive(active);
          },
          hasFile: hasFile
        })));
      }
    })), showError && /*#__PURE__*/React.createElement("div", {
      className: "text-danger mt-3"
    }, /*#__PURE__*/React.createElement(T, {
      source: "file-upload-error"
    }))),
    isValid: function isValid() {
      return hasFile && plagiarismFiles.every(function (file) {
        return file.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS;
      });
    }
  }];
  var close = function close(result) {
    var errorId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    setSubmitting(false);
    methods.reset(defaultValues);
    setCurrentPageIndex(0);
    setShowError(false);
    wordCountAttempts = 0;
    trackedUploadsRef.current.clear();
    onClose(result, errorId);
  };
  var handleClickNext = function handleClickNext() {
    if (screens[currentPageIndex].isValid()) {
      setShowError(false);
      if (currentPageIndex < screens.length - 1) {
        setCurrentPageIndex(currentPageIndex + 1);
      }
    } else {
      setShowError(true);
    }
  };
  var handleSubmit = function handleSubmit() {
    methods.handleSubmit(preprocessData(_submitPlagiarism))();
  };
  var _submitPlagiarism = function submitPlagiarism(data) {
    setSubmitting(true);
    var identity = data.plagiarismFiles[0].identity;
    var obj = {
      identity: identity
    };
    dispatch(createPlagiarism(obj, false, false)).then(function (res) {
      var plagiarismError = res.error;
      if (plagiarismError) {
        var errorId = plagiarismError.error;
        if (errorId === 'word-count-not-received') {
          if (wordCountAttempts < 12) {
            setTimeout(function () {
              return _submitPlagiarism(data);
            }, 5000);
            wordCountAttempts += 1;
            return;
          }
        }
        close(false, errorId);
      } else {
        dispatch(syncUser()).then(function () {
          close(true);
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement(Modal, {
    appElement: document.querySelector('#researcher-app'),
    isOpen: true,
    overlayClassName: "react-modal-overlay",
    className: "react-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: function onClick() {
      return close(false);
    },
    "aria-label": t('close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, screens[currentPageIndex].title)), /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "digital-edits"
  }, screens[currentPageIndex].content)), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: submitting || !screens[currentPageIndex].isValid(),
    className: "btn btn-primary btn-squared me-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "start"
  }), submitting && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return close(false);
    },
    className: "btn btn-secondary btn-squared"
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  }))))));
};
export default PlagiarismCheckDocumentModal;